define( function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/class2type.js
// module id = 59
// module chunks = 27